import route from "@MAIN/route";

export default {
  get_recommend(params) {
    return new Promise(resolve => {
      $.post(route('api.product.recommend'),params, data => {
        resolve(data)
      })
    })
  },
}

